import { cloneDeepWith, mapValues } from 'lodash'

import datajson from '../data/data.json'

export type Data = Record<string, SubCategoryData>
type SubCategoryData = Record<string, SubSubCategoryData>
type SubSubCategoryData = Record<string, ImpactValue>
type ImpactValue = Record<string, number>

type EmissionFactor = Record<
	string,
	{
		impact: number
		unit: string
		description: string
	}
>

function mapImpactValues(obj: EmissionFactor): ImpactValue {
	if (!obj) {
		return {}
	}

	return mapValues(obj, 'impact')
}

/* eslint-disable @typescript-eslint/no-explicit-any */
function convert(obj: Record<string, any>): Data {
	const newdata = cloneDeepWith(obj, value => {
		if (value.category_proxy || value.emission_factors) {
			return {
				...mapImpactValues(value.category_proxy),
				...mapImpactValues(value.emission_factors),
			}
		}
	})

	return newdata
}

function getData(): Data {
	return convert(datajson)
}

export { convert, getData }
